import Vue from "vue";
import Main from "./index.vue";

/**
 * 使用extend方法构建constructor动态创建组件
 */
const DownloadConstructor = Vue.extend(Main);

let instance;
const ContextMenu = (event, options = {}) => {
  if (instance && !instance._isDestroyed) {
    instance.destroyElement();
  }
  instance = new DownloadConstructor({
    data: {
      event,
      ...options
    }
  });
  instance.$mount();
  document.body.appendChild(instance.$el);
  return instance;
};
export default ContextMenu;
